import app from 'app';
import 'services';

import { API_PREFIX } from './etc/constants';

// ----- Load Runtime Configuration --------------------------------------------

const runtimeConfig = window.runtimeConfig || {};

// ----- Raven Setup -----------------------------------------------------------

app.config(SentryProvider => {
  if (runtimeConfig.sentryDsn) {
    SentryProvider.install({
      global: true,
      dsn: runtimeConfig.sentryDsn,
      options: {
        release: runtimeConfig.version || 'N/A'
      }
    });
  }
});

// ----- Angular Module Config -------------------------------------------------

// Make the API prefix available as an Angular constant to other modules.
app.value('apiPrefix', API_PREFIX);

app.constant('runtimeConfig', runtimeConfig);

module.exports = app.name;
export default app.name;
